"use strict";
// Styles for use with the lineage cartouches.
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.SingleLineageItemContainer = exports.CartoucheIconContainer = exports.CartoucheConnectorLine = exports.filteredOnItemIndicatorClass = exports.cartoucheContentInfoItemClass = exports.cartoucheContentInfoItemStyle = exports.LineageContentInfoItemBarRow = exports.lineageContentInfoItemSpaceRow = exports.LineageContentInfoItemLabelRow = exports.LineageContentInfoItemAnchorRowSelected = exports.LineageContentInfoItemAnchorRow = exports.anchoredContentInfoItemClass = exports.lineageContentInfoItemClass = exports.anchoredContentInfoItemStyle = exports.lineageContentInfoItemStyle = exports.baseContentInfoItemStyle = exports.ContentInfoContainer = exports.cartoucheIconButtonClass = exports.cartoucheIconButtonStyle = exports.lineageIconButtonClass = exports.lineageIconButtonStyle = exports.boldLineageItemClass = exports.anchorNameClass = exports.AnchoredLineageItemContainer = exports.activeLineageItemType = exports.cartoucheIconStyle = exports.CartoucheWrapper = void 0;
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var widgets_1 = require("@tableau/widgets");
var AnchorBlue = '#1A699E'; // from TFS 929971
var Colors = widgets_1.TabStyles.Colors;
var Spacing = widgets_1.TabStyles.Spacing;
var cartoucheSize = '45px';
var cartoucheLinkSize = '35px';
var cartoucheIconSize = '24px';
var lightBorder = '1px solid ' + Colors.F5;
var cartoucheBorder = '1px solid ' + Colors.F8;
var selectedBorder = '1px solid ' + AnchorBlue;
exports.CartoucheWrapper = data_catalog_shared_1.divWithStyle('CartoucheWrapper', __assign(__assign({}, data_catalog_shared_1.flexRowStyle), { flex: '0 0 auto' }));
exports.cartoucheIconStyle = data_catalog_shared_1.cssClass('cartoucheIconStyle', {
    display: 'block',
    border: lightBorder,
    borderRadius: '50%',
    padding: '4.5px',
    width: cartoucheIconSize,
    height: cartoucheIconSize,
    $nest: {
        '&:hover': {
            border: cartoucheBorder
        }
    }
});
exports.activeLineageItemType = data_catalog_shared_1.cssClass('activeLineageItemType', {
    border: selectedBorder,
    backgroundColor: AnchorBlue
});
exports.AnchoredLineageItemContainer = data_catalog_shared_1.divWithStyle('AnchoredLineageItem', {
    height: cartoucheSize,
    display: 'flex',
    flexDirection: 'row',
    flex: 'none',
    $nest: (_a = {},
        _a["& ." + exports.cartoucheIconStyle] = {
            backgroundColor: Colors.F5,
            padding: '9.5px',
        },
        _a["& ." + exports.activeLineageItemType] = {
            backgroundColor: AnchorBlue
        },
        _a)
});
exports.anchorNameClass = data_catalog_shared_1.cssClass('anchorName', data_catalog_shared_1.elideTextStyle, {
    fontSize: widgets_1.TabStyles.Typography.Sizing.Large,
    maxWidth: '100%'
});
exports.boldLineageItemClass = data_catalog_shared_1.cssClass('boldLineageItem', {
    fontWeight: 'bold'
});
exports.lineageIconButtonStyle = {
    height: cartoucheLinkSize,
};
exports.lineageIconButtonClass = data_catalog_shared_1.cssClass('lineageIconButton', exports.lineageIconButtonStyle);
exports.cartoucheIconButtonStyle = __assign(__assign({}, exports.lineageIconButtonStyle), { $nest: {
        '&:not(:last-of-type)': {
            marginBottom: Spacing.LargeSpace
        }
    } });
exports.cartoucheIconButtonClass = data_catalog_shared_1.cssClass('cartoucheIconButton', exports.cartoucheIconButtonStyle);
exports.ContentInfoContainer = data_catalog_shared_1.divWithStyle('ContentInfoContainer', __assign(__assign({}, data_catalog_shared_1.flexColumnStyle), { marginTop: 5, marginLeft: Spacing.MediumSpace }));
exports.baseContentInfoItemStyle = __assign(__assign({}, data_catalog_shared_1.flexColumnStyle), { flex: '1', color: widgets_1.TabStyles.Typography.Color.Primary, textDecoration: 'none', minWidth: 0 });
exports.lineageContentInfoItemStyle = __assign(__assign({}, exports.baseContentInfoItemStyle), { overflow: 'hidden', marginLeft: 16 });
exports.anchoredContentInfoItemStyle = __assign(__assign({}, exports.baseContentInfoItemStyle), { marginLeft: Spacing.MediumSpace });
exports.lineageContentInfoItemClass = data_catalog_shared_1.cssClass('LineageContentInfoItem', exports.lineageContentInfoItemStyle);
exports.anchoredContentInfoItemClass = data_catalog_shared_1.cssClass('AnchoredContentInfoItem', exports.anchoredContentInfoItemStyle);
exports.LineageContentInfoItemAnchorRow = data_catalog_shared_1.divWithStyle('LineageContentInfoItemAnchorRow', __assign(__assign({}, data_catalog_shared_1.flexColumnStyle), { flex: '1 1 0%', alignItems: 'flex-start', minHeight: 0 }));
exports.LineageContentInfoItemAnchorRowSelected = data_catalog_shared_1.divWithStyle('LineageContentInfoItemAnchorRowSelected', {
    display: 'flex',
    alignItems: 'center'
});
exports.LineageContentInfoItemLabelRow = data_catalog_shared_1.divWithStyle('LineageContentInfoItemLabelRow', {
    flex: '1 1 0%',
    display: 'flex',
    alignItems: 'center',
});
exports.lineageContentInfoItemSpaceRow = data_catalog_shared_1.cssClass('lineageContentInfoItemSpaceRow', {
    paddingTop: '4px', // to compensate for the height of the bar (below), to center label with icon
});
exports.LineageContentInfoItemBarRow = data_catalog_shared_1.divWithStyle('LineageContentInfoItemBarRow', {
    flex: 'none',
});
exports.cartoucheContentInfoItemStyle = {
    height: cartoucheLinkSize,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    color: widgets_1.TabStyles.Typography.Color.Primary,
    textDecoration: 'none',
    $nest: {
        '&:not(:last-of-type)': {
            marginBottom: Spacing.LargeSpace
        }
    }
};
exports.cartoucheContentInfoItemClass = data_catalog_shared_1.cssClass('CartoucheContentInfoItem', exports.cartoucheContentInfoItemStyle);
exports.filteredOnItemIndicatorClass = data_catalog_shared_1.cssClass('filteredOnItemIndicator', {
    paddingRight: widgets_1.TabStyles.Spacing.SmallSpace,
});
exports.CartoucheConnectorLine = data_catalog_shared_1.divWithStyle('CartoucheConnectorLine', {
    width: 22.5,
    borderRight: lightBorder,
    height: Spacing.LargeSpace,
    flex: 'none',
});
exports.CartoucheIconContainer = data_catalog_shared_1.divWithStyle('CartoucheIconContainer', __assign(__assign({}, data_catalog_shared_1.flexColumnStyle), { padding: '5px 4px', border: lightBorder, borderRadius: cartoucheLinkSize }));
exports.SingleLineageItemContainer = data_catalog_shared_1.divWithStyle('SingleLineageItem', {
    marginLeft: Spacing.DefaultSpace,
});
//# sourceMappingURL=LineageCartoucheStyles.js.map